import { useState } from 'react';

import { Modal, Text } from '@thefarmersfront/kitchen';

import { ModalContentsContainer, ModalSection, Table } from '~/components/common';

import { useModal } from '~/hooks/common';
import { getClaimReturnDetailInspectionColumnDefs, getClaimReturnDetailTrackingColumnDefs } from '~/utils';

import { ClaimDetailInspectionImageModal } from '../../ClaimDetailInspectionImageModal';

import type { TypeReturnDetailData } from '~/types/claim.types';

import styles from './ClaimReturnDetailModal.module.scss';

const ClaimReturnDetailModal = ({
  isOpen,
  data,
  onClose,
}: {
  isOpen: boolean;
  data: TypeReturnDetailData | null;
  onClose: () => void;
}) => {
  const [selectedImageList, setSelectedImageList] = useState<string[] | null>(null);

  const { columnDefs: trackingColumnDefs } = getClaimReturnDetailTrackingColumnDefs();
  const { columnDefs: inspectionColumnDefs, gridOptions: inspectionGridOptions } =
    getClaimReturnDetailInspectionColumnDefs({
      onClickViewInspectionImage: (imageList) => {
        setSelectedImageList(imageList);
        inspectionImageModal.handleOpenModal();
      },
    });

  const inspectionImageModal = useModal();

  if (!data) return null;

  return (
    <>
      <Modal title="반품 신청 상세" size="xlarge" open={isOpen} onConfirm={onClose}>
        <ModalContentsContainer>
          <ModalSection title="회수 신청 정보">
            <div className={styles['info-container']}>
              <Row label="반품요청번호" value={data.returnReceiptId} />
              <Row label="원주문 수령자명" value={data.member.name} />
              <Row label="기본주소" value={data.returnPlace.primaryAddress} />
              <Row label="상세주소" value={data.returnPlace.secondaryAddress ?? '-'} />
            </div>
          </ModalSection>
          <ModalSection title="회수 송장 정보">
            <Table
              className={styles['table']}
              data={data.returnOrderTrackings ?? []}
              options={{ columnDefs: trackingColumnDefs }}
              rowStatusType="NO_DATA"
            />
          </ModalSection>
          <ModalSection title="검수 처리 상세">
            <Table
              className={styles['table']}
              data={data.returnGoodsInspections}
              options={{ columnDefs: inspectionColumnDefs, ...inspectionGridOptions }}
              rowStatusType="NO_DATA"
            />
          </ModalSection>
        </ModalContentsContainer>
      </Modal>
      {inspectionImageModal.isOpen && selectedImageList && (
        <ClaimDetailInspectionImageModal
          mode="return"
          isOpen={inspectionImageModal.isOpen}
          imageList={selectedImageList}
          onClose={inspectionImageModal.handleCloseModal}
        />
      )}
    </>
  );
};

export default ClaimReturnDetailModal;

const Row = ({ label, value }: { label: string; value: string }) => {
  return (
    <div className={styles['row']}>
      <Text className={styles['label']} size="large" weight="semi-bold" element="span">
        {label}
      </Text>
      <Text className={styles['value']} size="large" element="span">
        {value}
      </Text>
    </div>
  );
};
